'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('HubStyleTokens/colors');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageContainer = _styledComponents2.default.div.withConfig({
  displayName: 'PageContainer'
})(['background-color:', ';min-height:100vh;'], _colors.OLAF);

exports.default = PageContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/PageContainer.js
// module id = 175
// module chunks = 3 4